import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_BACKEND_URL;
const SKIP_AUTH = process.env.REACT_APP_SKIP_AUTH === 'true';

const socket = SKIP_AUTH
  ? io(SOCKET_URL, { transports: ["websocket"] })
  : io(SOCKET_URL, {
      transports: ["websocket"],
      auth: { token: localStorage.getItem('authToken') }
    });

export default socket;

